module.exports = __webpack_public_path__ + "img/gb13871-92_50x72x8.prt.e513c2ef.jpg";